export default {
  "login": "mosh-hamedani",
  "id": 5441280,
  "node_id": "MDQ6VXNlcjU0NDEyODA=",
  "avatar_url": "https://avatars1.githubusercontent.com/u/5441280?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/mosh-hamedani",
  "html_url": "https://github.com/mosh-hamedani",
  "followers_url": "https://api.github.com/users/mosh-hamedani/followers",
  "following_url": "https://api.github.com/users/mosh-hamedani/following{/other_user}",
  "gists_url": "https://api.github.com/users/mosh-hamedani/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/mosh-hamedani/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/mosh-hamedani/subscriptions",
  "organizations_url": "https://api.github.com/users/mosh-hamedani/orgs",
  "repos_url": "https://api.github.com/users/mosh-hamedani/repos",
  "events_url": "https://api.github.com/users/mosh-hamedani/events{/privacy}",
  "received_events_url": "https://api.github.com/users/mosh-hamedani/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Mosh Hamedani",
  "company": null,
  "blog": "http://programmingwithmosh.com",
  "location": "Melbourne, Australia",
  "email": null,
  "hireable": null,
  "bio": null,
  "twitter_username": null,
  "public_repos": 15,
  "public_gists": 1,
  "followers": 6549,
  "following": 1,
  "created_at": "2013-09-12T04:38:33Z",
  "updated_at": "2020-09-09T00:22:54Z"
}